"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractBaseListResponseSchema = exports.ContractPaginationResponseSchema = exports.ContractPaginationQueryParamsSchema = exports.ContractAuthHeaderSchema = exports.EmptyBodySchema = exports.BooleanQueryParamSchema = exports.NonNegativeFloatSchema = exports.NonNegativeIntSchema = exports.NegativeFloatSchema = exports.NegativeIntSchema = exports.PositiveFloatSchema = exports.PositiveIntSchema = exports.DateSchema = exports.UUIDSchema = exports.PasswordSchema = exports.EmailSchema = void 0;
const zod_1 = require("zod");
const constant_1 = require("./constant");
exports.EmailSchema = zod_1.z.string().email();
exports.PasswordSchema = zod_1.z.string();
exports.UUIDSchema = zod_1.z.string().uuid();
exports.DateSchema = zod_1.z.coerce.date();
exports.PositiveIntSchema = zod_1.z.number().int().positive();
exports.PositiveFloatSchema = zod_1.z.number().positive();
exports.NegativeIntSchema = zod_1.z.number().int().negative();
exports.NegativeFloatSchema = zod_1.z.number().negative();
exports.NonNegativeIntSchema = zod_1.z.number().int().nonnegative();
exports.NonNegativeFloatSchema = zod_1.z.number().nonnegative();
exports.BooleanQueryParamSchema = zod_1.z.preprocess((val) => {
    if (val === 'false')
        return false;
    if (val === 'true')
        return true;
    return undefined;
}, zod_1.z.boolean().optional());
exports.EmptyBodySchema = zod_1.z.object({});
exports.ContractAuthHeaderSchema = zod_1.z.object({ authorization: zod_1.z.string() });
exports.ContractPaginationQueryParamsSchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().positive().default(constant_1.DEFAULT_PAGE),
    pageSize: zod_1.z.coerce.number().int().positive().default(constant_1.DEFAULT_PAGE_SIZE),
});
exports.ContractPaginationResponseSchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().positive(),
    pageSize: zod_1.z.coerce.number().int().positive(),
    total: zod_1.z.coerce.number().int().nonnegative(),
    totalPages: zod_1.z.coerce.number().int().nonnegative(),
});
exports.ContractBaseListResponseSchema = zod_1.z.object({ meta: zod_1.z.object({ pagination: exports.ContractPaginationResponseSchema }) });
